import React from "react";
import { Field } from "formik";

import { DialogContent, TextField } from "@material-ui/core";

import TabPanel from "../TabPanel";
import QueueSelect from "../QueueSelect";

/**
 * Tab "Filas" da conexão — filas atendidas e Wavoip.
 *
 * Os campos de integração ("Integração", "Disparar Integração ao Encerrar
 * Ticket" e o tipo de integração que dependia dele) saíram no #4440. O motor de
 * integração (Typebot/N8N/Dialogflow) continua existindo no backend — o que
 * saiu foi a configuração pela tela. O nome do arquivo é histórico; o rótulo da
 * aba já é "Filas" (`whatsappModal.tabs.queues`).
 */
const IntegrationsTab = ({
  tab,
  classes,
  selectedQueueIds,
  handleChangeQueue,
  showWavoipCall,
}) => {
  return (
    <TabPanel className={classes.container} value={tab} name="integrations">
      <DialogContent dividers>
        <QueueSelect
          selectedQueueIds={selectedQueueIds}
          onChange={(selectedIds) => handleChangeQueue(selectedIds)}
        />
        {showWavoipCall && (
          <div>
            <Field
              as={TextField}
              label="Wavoip"
              fullWidth
              name="wavoip"
              variant="outlined"
              margin="dense"
            />
          </div>
        )}
      </DialogContent>
    </TabPanel>
  );
};

export default IntegrationsTab;
